import { Button } from "@/components/ui/button";
import { Achievement } from "@/components/ui/home/achievement";
// import { CurrencyGlassOrbs } from "@/components/ui/home/CurrencyGlassOrbs";
import MetallicPaint from "@/components/MetallicPaint";
import logoIconUrl from "@/assets/logo-icon.svg";

type HomePageProps = {
  onNavigate?: (path: string) => void;
};

export function HomePage({ onNavigate }: HomePageProps) {
  const go = (path: string) => {
    if (onNavigate) onNavigate(path);
    else if (typeof window !== "undefined") {
      window.history.pushState({}, "", path);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  };

  return (
    <>
      {/* Hero */}
      <section className="relative flex min-h-[85vh] flex-col justify-center px-6 pt-12 pb-24 md:min-h-[90vh] md:px-12">
        <div className="mx-auto w-full max-w-5xl">
          {/* 上段: 左タグライン / 右メタリック */}
          <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2 md:gap-16">
            {/* Left: タグライン */}
            <div className="flex flex-col items-start text-left">
              <h1 className="font-serif text-4xl font-light leading-tight tracking-tight text-foreground md:text-5xl lg:text-6xl">
                技術と仕組みで
                世界の取引を解決する。
              </h1>
              <p className="mt-6 text-sm text-muted-foreground md:text-base">
                国境を越えた取引を、より速く、確実に。私たちは、テクノロジーで国際的な取引の課題を解決します。
              </p>
              <div className="mt-10 flex flex-wrap items-center gap-4">
                <Button
                  variant="default"
                  size="lg"
                  className="min-w-[160px]"
                  onClick={() => go("/service")}
                >
                  サービス
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  className="min-w-[160px]"
                  onClick={() => go("/about")}
                >
                  会社概要
                </Button>
              </div>
            </div>
            {/* Right: メタリックペイント（ガラスオーブは一旦非表示） */}
            <div className="relative h-[280px] w-full md:h-[400px]" style={{ minHeight: 280 }}>
              {/* <CurrencyGlassOrbs /> */}
              <MetallicPaint
                imageSrc={logoIconUrl}
                seed={42}
                scale={4}
                patternSharpness={1}
                noiseScale={0.5}
                speed={0.3}
                liquid={0.75}
                mouseAnimation={false}
                brightness={2}
                contrast={0.5}
                refraction={0.01}
                blur={0.015}
                chromaticSpread={2}
                fresnel={1}
                angle={0}
                waveAmplitude={1}
                distortion={1}
                contour={0.2}
                lightColor="#ffffff"
                darkColor="#000000"
                tintColor="#feb3ff"
              />
            </div>
          </div>
          {/* 下段: 中央に企業ロゴロール */}
          <div className="mt-16 w-full">
            <Achievement />
          </div>
        </div>
      </section>
    </>
  );
}
